import React from 'react'
import IconLabel from '../../common/icon-label'
import { ClockFill } from 'react-bootstrap-icons'
import HourLabel from '../../hours/label'
import DurationLabel from '../../durations/label'

const HourDurationIconLabel = ({
    experience = {},
    size
}) => {

    return (
        <IconLabel
            size={size}
            icon={ClockFill}
        >
            <HourLabel hourId={experience.hourId} /> - <DurationLabel durationId={experience.durationId} />
        </IconLabel>
    )
}

export default HourDurationIconLabel